import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import DeviceManager from '../../containers/device_manager';
import './guest.scss';

export default class Guest extends React.Component {
  static propTypes = {
    resolveInvite: PropTypes.func.isRequired,
    clearInvite: PropTypes.func.isRequired,
    invite: PropTypes.shape({
      userId: PropTypes.number,
      inviteId: PropTypes.string,
    }),
  };

  static defaultProps = {
    invite: null,
  };

  constructor(props) {
    super(props);

    this.state = { loading: true };
  }

  componentWillMount() {
    const inviteId = queryString.parse(window.location.search).inviteId;
    this.props.resolveInvite(inviteId)
      .then(() => this.setState({ loading: false }));
  }

  componentWillUnmount() {
    this.props.clearInvite();
  }

  renderStatus(status) {
    return (
      <div className="status">
        { status }
      </div>
    );
  }

  render() {
    return (
      <div className="guest">
        {
          /* eslint-disable  no-nested-ternary */
          this.state.loading
          ? this.renderStatus('Loading...')
          : this.props.invite
            ? <DeviceManager {...this.props} />
            : this.renderStatus('It seems you no longer have access to this TeamHub account.')
          /* eslint-enable  no-nested-ternary */
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/guest/guest.jsx